import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth.js'
import search from './modules/search.js'
import positioning from './modules/positioning.js'
import transition from './modules/transition.js'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    auth,
    search,
    positioning,
    transition
  },
  state: {
    loading: false,
    forbidden: false,
    jobOfferLoading: false
  },
  mutations: {
    onLoading (state, mode) {
      state.loading = mode
    },
    forbidden (state, mode) {
      state.forbidden = mode
    }
  },
  plugins: [createPersistedState()]
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js